module.exports = __webpack_public_path__ + "static/one-page-seo-e9909a05218df925e128e380208d9c8d.png";